const AnimStrateChiffres = {
    init() : void {
        const $elements = document.querySelectorAll<HTMLElement>('.animated-chiffres');
        const _this = this;

        $elements.forEach($element => {
            const observer = new IntersectionObserver(entries => {
                if (entries[0].intersectionRatio <= 0 || $element.classList.contains('animated')) {
                    return;
                }

                if (!isNaN(parseFloat($element.innerHTML))) {
                    _this.animateValue($element, 0, parseFloat($element.innerHTML), 2000);
                }

                $element.classList.add('animated');
            }, { threshold: 0.2 });
                
            observer.observe($element);
        });
    },

    /**
     * @param {HTMLElement} $element 
     * @param {number} start 
     * @param {number} end 
     * @param {number} duration 
     * 
     * @return {void}
     */
    animateValue($element: HTMLElement, start: number, end: number, duration: number) : void {
        if (start === end) {
            return;
        }

        const range = end - start;
        let current = start;
        const increment = end > start ? this.adjustIncrement(end) : -this.adjustIncrement(end);
        const stepTime = Math.abs(Math.floor(duration / range));
        const timer = setInterval(() => {
            current += increment;
            $element.innerHTML = this.numberWithSpaces(current);
            if (current >= end) {
                $element.innerHTML = this.numberWithSpaces(current);
                clearInterval(timer);
            }
        }, stepTime);
    },

    /**
     * @param {number} value
     * 
     * @return {number}
     */
    adjustIncrement(value: number) : number {
        let increment = 1;
        let incrementMultiple = 1;
        const initialValue = value;
        if (initialValue >= 1000) {
            while (value / 1000 >= 1) {
                value = value / 10;
                incrementMultiple = incrementMultiple + 1;
            }
            increment = increment * Math.pow(10, incrementMultiple - 1);
        } else if (initialValue >= 100) {
            increment = increment * 10;
        }
        return increment;
    },

    /**
     * @param {number} x 
     * 
     * @return {string}
     */
    numberWithSpaces(x: number) : string {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
};

export default AnimStrateChiffres;
